module.exports = __webpack_public_path__ + "img/logo100.fd5100e9.png";